import React from 'react';
import { QCheckbox, QIcon, QStack, QText } from '@qualio/ui-components';

export const AI_PERMISSION_IDS = ['ai_enabled', 'copilot_enabled'];

type PermissionsControlProps = {
  label: string;
  description: string;
  isChecked: boolean;
  handleChange: (configId: string, enabled: boolean) => void;
  permissionId: string;
  permissionLabel: string;
  'data-cy': string;
};

const PermissionControlLabel = ({
  label,
  description,
  showAiIcon,
}: Pick<PermissionsControlProps, 'label' | 'description'> & { showAiIcon?: boolean }) => {
  return (
    <QStack spacing="2">
      <QStack direction="row" alignItems="center" spacing="2">
        {showAiIcon && <QIcon iconName="QualioAI" size="sm" />}
        <QText fontWeight="semibold" fontSize="16px">
          {label}
        </QText>
      </QStack>
      <QText fontSize="14px" color="gray.500">
        {description}
      </QText>
    </QStack>
  );
};

export const PermissionControl = ({
  label,
  description,
  permissionId,
  permissionLabel,
  handleChange,
  isChecked,
  ...props
}: PermissionsControlProps) => {
  const isAiPermission = AI_PERMISSION_IDS.includes(permissionId);
  return (
    <QStack spacing="4">
      <PermissionControlLabel label={label} description={description} showAiIcon={isAiPermission} />
      <QCheckbox
        data-cy={props['data-cy']}
        key={permissionId}
        onChange={() => handleChange(permissionId, !isChecked)}
        isChecked={isChecked}
      >
        {permissionLabel}
      </QCheckbox>
    </QStack>
  );
};
